import axios from '@api';

/**
 * login - Logs the user in.
 */
export const login = ({ email, password }: { email: string; password: string }) => {
  return axios({
    data: { login: email, password },
    method: 'post',
    url: '/api/login',
    withCredentials: true,
  });
};

/**
 * logout - Logs the user out.
 */
export const logout = () => {
  return axios({
    method: 'get',
    url: '/api/logout',
    withCredentials: true,
  });
};
